(() => {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    initCarousel();
  }

  function initCarousel() {
    const section = document.querySelector('.reviews');
    if (!section) {
      console.log('Reviews section not found');
      return;
    }

    const carousel = section.querySelector('[data-reviews-carousel]');
    const prevBtn = section.querySelector('.reviews__nav--prev');
    const nextBtn = section.querySelector('.reviews__nav--next');

    if (!carousel) {
      console.log('Carousel element not found');
      return;
    }

    if (!prevBtn || !nextBtn) {
      console.log('Navigation buttons not found');
      return;
    }

    console.log('Initializing reviews carousel');

    function scrollToCard(direction) {
      const cardWidth = carousel.offsetWidth;
      const scrollAmount = cardWidth;
      
      const currentScroll = carousel.scrollLeft;
      const targetScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;
      
      console.log(`Scrolling ${direction}: ${currentScroll} -> ${targetScroll}`);
      
      carousel.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Previous button clicked');
      scrollToCard('prev');
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Next button clicked');
      scrollToCard('next');
    });

    // Hide navigation if only one review
    if (carousel.children.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    console.log('Carousel initialized successfully');
  }
})();
